// 토모플레이 - 지사 - 원별 사용량 - 상세 페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import { format, addDays, addMonths, isSameMonth } from "date-fns";

import axios from "@app/lib/axios";

import ReactEcharts from "echarts-for-react";
import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";
import AgGridReactEx from "@app/components/AgGridReactEx";
import CommonVerticalBarChart from "@app/components/CommonVerticalBarChart";

import playStyle from "../components/style";

const ContentClass = forwardRef(({ statPeriod, branchName, nurseryId, classId, nurseryName, updateViewSubOption, onClassSelected }, ref) => {
    const [stat, setStat] = useState(false);
    const [statCountDate, setCountByDate] = useState(false);
    const [statContent, setStatContent] = useState(false);
    const [statContentSum, setStatContentSum] = useState(false);
    const [statNurseryUser, setNurseryUser] = useState(false);
    const [statClassCount, setClassCount] = useState(false);
    const [barChartSize, setBarChartSize] = useState(false);
    const [statChildContent, setChildContent] = useState(false);

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            var content = [];
            var contentSum = [];
            statContent.map((s) => content.push(s.value));
            statContentSum.map((s) => contentSum.push(s.value));
            const excelData = {
                fileName: "토모플레이_원통계",
                sheets: [
                    {
                        name: "콘텐츠 사용량(순)",
                        title: `콘텐츠 순 사용량`,
                        columnTitle: [].concat(playStyle.seriesPlayChart.map((s) => s.name)),
                        data: [content],
                    },
                    {
                        name: "콘텐츠 사용량(누적)",
                        title: `콘텐츠 순 사용랑`,
                        columnTitle: [].concat(playStyle.seriesPlayChart.map((s) => s.name)),
                        data: [contentSum],
                    },
                    {
                        name: "기간별 사용량 (누적)",
                        title: `기간별 콘텐츠 누적 실행 수`,
                        columnTitle: ["", "누적 실행 수"],
                        data: statCountDate ? statCountDate.map((s) => [s.statDate, s.playCountSum]) : [],
                    },
                    {
                        name: "원아별 사용량",
                        title: `원아별 사용량`,
                        columnTitle: ["", "누적 실행 수"],
                        data: statChildContent ? statChildContent.map((s) => [s.childName, s.playCount]) : []
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = useCallback(() => {
        axios({
            method: "POST",
            url: `/api/play_stat/play/${nurseryId}/${classId}/class/content`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const stat = result.data.data;
                    let statPlayCount = [];

                    let start = new Date(statPeriod.startDate);
                    let day = new Date(statPeriod.startDate);
                    for (let i = 0; i < 99; i++) {
                        const statDate = format(day, statPeriod.type === "year" ? "yyyy-MM" : "yyyy-MM-dd");
                        const statDateStr = format(day, statPeriod.type === "year" ? "yyyy-MM" : "MM-dd");
                        const sContent = stat.playCountDate.find((s) => s.statDate === statDate);

                        statPlayCount.push({ ...sContent, statDate: statDateStr });
                        if (statPeriod.type === "week") {
                            day = addDays(day, 1);
                            if (i >= 6) break;
                        } else if (statPeriod.type === "month") {
                            day = addDays(day, 1);
                            if (!isSameMonth(day, start)) break;
                        } else {
                            // year
                            day = addMonths(day, 1);
                            if (i > 11) break;
                        }
                    }

                    var statContent = [];
                    var statContentSum = [];

                    playStyle.seriesPlayChart.map((s) => {
                        var count = stat.playCountMenu.find((a) => a.menu == s.field);
                        statContent.push({ id: s.field, name: s.name, value: count ? count.playCount : 0 });
                        statContentSum.push({ id: s.field, name: s.name, value: count ? count.playCountSum : 0 });
                    });

                    var barChartSize = 200;
                    if (stat.childPlayCount.length > 3) barChartSize = stat.childPlayCount.length * 60;

                    setBarChartSize(barChartSize);
                    setClassCount(stat.classCount);
                    setStat(stat);
                    setChildContent(stat.childPlayCount);
                    setCountByDate(statPlayCount);
                    setStatContent(statContent);
                    setStatContentSum(statContentSum);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    }, [statPeriod, classId]);
    useEffect(() => {
        getStat();
        return () => {};
    }, [getStat]);

    const optionContentSum = {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(50,50,50,0.9)",
            formatter: (params, chart, test) => {
                const total = statContentSum ? statContentSum.reduce((ac, current) => ac + current.value, 0) : 0;
                const tip = statContentSum
                    ? statContentSum
                          .map(
                              (s, idx) =>
                                  `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 200px'>${`<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${playStyle.seriesPlayColor.normal[idx]};"></span>`}(누적)${
                                      s.name
                                  }: ${s.value.toLocaleString()}, ${((s.value / total) * 100).toFixed(1)}%</div>`
                          )
                          .join("")
                    : "";
                return tip + `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold m-1' style='width: 200px'>합계: ${total.toLocaleString()}</div>`;
            },
        },
        series: [
            {
                type: "pie",
                data: statContentSum,
                radius: ["0%", "85%"],
                center: ["40%", "45%"],
                animation: false,
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "right",
                },
                color: playStyle.seriesPlayColor.normal,
            },
        ],
        legend: {
            orient: "vertical",
            x: "right",
            y: "top",
        },
    };

    const optionContent = {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(50,50,50,0.9)",
            formatter: (params, chart, test) => {
                const total = statContent ? statContent.reduce((ac, current) => ac + current.value, 0) : 0;
                const tip = statContent
                    ? statContent
                          .map(
                              (s, idx) =>
                                  `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 200px'>${`<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${playStyle.seriesPlayColor.normal[idx]};"></span>`}${
                                      s.name
                                  }: ${s.value.toLocaleString()}, ${((s.value / total) * 100).toFixed(1)}%</div>`
                          )
                          .join("")
                    : "";
                return tip + `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold m-1' style='width: 200px'>합계: ${total.toLocaleString()}</div>`;
            },
        },
        series: [
            {
                type: "pie",
                data: statContent,
                radius: ["0%", "85%"],
                center: ["40%", "45%"],
                animation: false,
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "right",
                },
                color: playStyle.seriesPlayColor.normal,
            },
        ],
        legend: {
            orient: "vertical",
            x: "right",
            y: "top",
        },
    };

    const playDateChartOption = {
        xAxis: { field: "statDate" },
        yAxis: {
            name: "건",
            series: [{ name: "실행 수", field: "playCountSum", stack: "base", option: { itemStyle: { color: "#5B9BD5" } } }],
        },
        stacks: [{ stack: "base", showPercent: true, showSum: false, showSumTooltip: true }],
        tooltipFormatter: (params, chart, test) => {
            var tooltipTitle = "";
            var total = 0;

            params.map((e) => {
                if (e.seriesName.indexOf("Sum-") < 0) {
                    tooltipTitle = e.name;
                    total += e.value;
                }
            });

            var tooltip = tooltipTitle + '<div class="text-left">';
            tooltip += `<b>합계: ${total.toLocaleString()}</b>`;
            tooltip += `</div>`;

            return tooltip;
        },
        showLegend: false,
        legend: {
            x: "right",
            y: "top",
        },
        sort: false,
        grid: {
            top: "15%",
            left: "5%",
            right: "5%",
        },
    };
    const chartOptionContent = {
        yAxis: { field: "childName" },
        xAxis: {
            name: "건",
            series: [{ name: "실행 수", field: "playCount", stack: "base", option: { itemStyle: { color: "#7B7BD9" } } }],
        },
        stacks: [{ stack: "base", showSum: false, showSumTooltip: false, showPercent: false }],
        showLegend: true,
        legend: {
            x: "right",
            y: "top",
        },
        sort: false,
        grid: {
            top: "12%",
            left: "10%",
            right: "5%",
            bottom: "10%",
        },
    };

    return (
        <div>
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 사용 현황 (순 사용량)</h5>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <ReactEcharts theme="macarons" option={optionContent} style={{ height: `280px` }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 사용 현황 (누적 사용량)</h5>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <ReactEcharts theme="macarons" option={optionContentSum} style={{ height: `280px` }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">기간별 사용량 (누적 사용량)</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statCountDate} chartOption={playDateChartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">원아별 사용량</h5>
                        </div>
                        <div className="card-body" style={{ height: `${barChartSize}px` }}>
                            <CommonVerticalBarChart chartData={statChildContent} chartOption={chartOptionContent} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ContentClass;
